export default {
  MuiToggleButtonGroup: {
    styleOverrides: {
      root: {
        borderRadius: 6
      }
    }
  },
  MuiToggleButton: {
    styleOverrides: {
      root: {
        borderRadius: 6
      }
    }
  }
}
